var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7949 32.075C18.2929 32.0122 18.8537 31.1181 20.6616 31.1181C22.4694 31.1181 22.9792 32.075 24.54 32.0357C26.1478 32.0122 27.1596 30.5965 28.1283 29.1534C29.2851 27.5142 29.7518 25.8946 29.7675 25.8122C29.7322 25.8005 26.6459 24.624 26.6145 21.0593C26.5871 18.0867 29.0498 16.6397 29.1596 16.573C27.7675 14.5416 25.6067 14.2632 24.8459 14.2397C23.0302 14.0514 21.2733 15.3259 20.3478 15.3259C19.4224 15.3259 17.9832 14.2593 16.4498 14.2907C14.4773 14.322 12.6263 15.4632 11.6145 17.2358C9.52433 20.8554 11.0851 26.1691 13.0851 29.0946C14.0851 30.5259 15.2577 32.1259 16.7871 32.071L16.7949 32.075Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6663 12.3189C24.4702 11.3111 25.0231 9.94246 24.8702 8.54639C23.7016 8.59737 22.2428 9.35423 21.4035 10.3385C20.6584 11.2091 19.9957 12.6327 20.1683 13.9699C21.4781 14.068 22.8232 13.3072 23.6663 12.315V12.3189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.199219 0.314453V40.3144H40.1992V0.314453H0.199219ZM39.4149 39.5301H0.983532V1.09877H39.4149V39.5301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialApple);
export default __webpack_public_path__ + "static/media/social_apple.81137bdff5402f2b942a05424459640e.svg";
export { ForwardRef as ReactComponent };